const athena = {

    "ApiUrl": "https://bcxnxnwmrbdl5izvywhxv562zy.appsync-api.ap-south-1.amazonaws.com/graphql",
    "Region": "ap-south-1",
    "AuthMode": "AMAZON_COGNITO_USER_POOLS",
    "ClientDatabasePrefix": "athenacontentapi_AMAZON_COGNITO_USER_POOLS"
}

export default athena;